import { ClientContact } from "@jugl-web/rest-api";
import { TicketContact } from "@jugl-web/rest-api/tickets/models/common-types";
import { Avatar } from "@jugl-web/ui-kit";
import { NewContactDialog } from "@web-src/modules/client-support/components/NewContactDialog";
import { TicketContactPickerPopover } from "@web-src/modules/client-support/components/TicketContactPickerPopover/TicketContactPickerPopover";
import { FC, useState } from "react";
import {
  TicketDetailItem,
  TicketDetailItemPlaceholder,
  TicketDetailItemText,
} from "../TicketDetailItem";

interface ContactDetailItemProps {
  contact: TicketContact | null;
  errorMessage?: string;
  onChange: (contact: TicketContact) => void;
}

export const ContactDetailItem: FC<ContactDetailItemProps> = ({
  contact,
  errorMessage,
  onChange,
}) => {
  const [isNewContactDialogOpen, setIsNewContactDialogOpen] = useState(false);

  const handleContactCreated = (createdContact: ClientContact) => {
    onChange({
      id: createdContact.id,
      name: createdContact.name ?? "Unknown",
    });
  };

  return (
    <>
      <TicketContactPickerPopover
        contact={contact}
        onChange={onChange}
        onNewContactSelect={() => setIsNewContactDialogOpen(true)}
        renderTrigger={({ Trigger, triggerRef, isOpen }) => (
          <Trigger
            as={TicketDetailItem}
            ref={triggerRef}
            isInteractive
            isActive={isOpen}
            errorMessage={errorMessage}
            label="Customer"
            content={
              contact ? (
                <TicketDetailItemText
                  startSlot={
                    <Avatar size="sm" imageUrl={null} username={contact.name} />
                  }
                  text={contact.name}
                />
              ) : (
                <TicketDetailItemPlaceholder />
              )
            }
          />
        )}
      />
      <NewContactDialog
        isOpen={isNewContactDialogOpen}
        onRequestClose={() => setIsNewContactDialogOpen(false)}
        onContactCreated={handleContactCreated}
      />
    </>
  );
};
